module.exports = __webpack_public_path__ + "static/media/Logo_Montcalm.fd94c341.jpg";